export const getTOSEARCH = (state) => {
    return state.toSearch
}

export const getFROMDAY = (state) => {
    return state.fromDate.day
}
export const getFROMMONTH = (state) => {
    return state.fromDate.month
}
export const getFROMYEAR = (state) => {
    return state.fromDate.year
}

export const getTODAY = (state) => {
    return state.toDate.day
}
export const getTOMONTH = (state) => {
    return state.toDate.month
}
export const getTOYEAR = (state) => {
    return state.toDate.year
}

export const getSHOWEMAILTYPEBLANK = (state) => {
    return state.showEmailType.show_blank
}
export const getSHOWEMAILTYPEUNUSED = (state) => {
    return state.showEmailType.show_unused
}
export const getSHOWEMAILTYPEUSED = (state) => {
    return state.showEmailType.show_used
}
export const getSHOWEMAILTYPEJUNK = (state) => {
    return state.showEmailType.show_junk
}
export const getSHOWEMAILTYPECOPY = (state) => {
    return state.showEmailType.show_copy
}

export const getHIDEMARKEDREAD = (state) => {
    return state.hideMarkedRead
}

export const getFLAG_C = (state) => {
    return state.flags.c
}
export const getFLAG_EN = (state) => {
    return state.flags.en
}
export const getFLAG_N = (state) => {
    return state.flags.n
}
export const getFLAG_RL = (state) => {
    return state.flags.rl
}
export const getFLAG_TC = (state) => {
    return state.flags.tc
}
export const getFLAG_TL = (state) => {
    return state.flags.tl
}
export const getFLAG_ID = (state) => {
    return state.flags.id
}
export const getFLAG_PT = (state) => {
    return state.flags.pt
}
export const getFLAG_PN = (state) => {
    return state.flags.pn
}
export const getFLAG_AE = (state) => {
    return state.flags.ae
}
export const getFLAG_PO = (state) => {
    return state.flags.po
}
export const getFLAG_HR = (state) => {
    return state.flags.hr
}
export const getFLAG_RE = (state) => {
    return state.flags.re
}

export const getPANELIST = (state) => {
    return state.panelist
}

export const getCOUNTRY = (state) => {
    return state.country
}

export const getBUSINESSOWENER = (state) => {
    return state.businessOwner
}

export const getPARTITION = (state) => {
    return state.partition
}

export const getIsFromSearch = (state) => {
    return state.isFromSearch
}

export const getState = (state) => {
    return state
}

export const getSearchQuery = (state) => {
    return state.searchQuery
}

export const getSearchId = (state) => {
    return state.searchId
}

export const getSearchBy = (state) => {
    return state.searchBy
}

export const getSearchById = (state) => {
    return state.searchBy.id
}

export const getSearchBySubject = (state) => {
    return state.searchBy.subject
}

export const getSearchByBody = (state) => {
    return state.searchBy.body
}

export const getSearchBySender = (state) => {
    return state.searchBy.sender
}

export const getSelectedState = (state) => {
    return state.state
}

export const getPanelistType = (state) => {
    return state.panelist_type
}

export const getSearchBySenderName = (state) => {
    return state.searchBy.sender_name
}

export const getSearchBySenderEmail = (state) => {
    return state.searchBy.sender_email
}
